<!-- Title | Add button -->
<div class="tw-flex tw-items-center tw-justify-between tw-gap-[10px] tw-px-4 tw-py-3 md:tw-px-[10px] lg:tw-px-0">
  <h2 class="tw-text-2xl">Customers</h2>
  <ate-button-control class="tw-w-fit tw-min-w-[48px] tw-p-3 md:tw-flex md:tw-gap-2" [routerLink]="['../add']" color="cta">
    <ate-icon class="tw-h-4 tw-w-4" name="plus-v3"></ate-icon>
    <span class="tw-hidden md:tw-block">Add Customer</span>
  </ate-button-control>
</div>

<!-- Search | Filter button | Sort -->
<div class="customer-list-toolbar tw-mb-4">
  <div class="tw-flex tw-items-center tw-gap-[10px] tw-px-4 md:tw-px-[10px] lg:tw-px-0">
    <!-- Search -->
    <div class="tw-flex tw-flex-1">
      <ate-text-input-control
        class="search-input tw-w-full"
        size="small"
        [value]="searchTerm"
        [model-key]="searchModelKey"
        [attr.model-key]="searchModelKey"
        (onValueChanges)="onSearchInput($event)"
        placeholder="Search Customers..."
        icon="search-v2">
      </ate-text-input-control>
    </div>

    <!-- Filter button -->
    <button
      class="ate-btn btn-filter tw-flex tw-items-center tw-justify-center tw-gap-[5px]"
      (click)="toggleFiltersPanel()"
      [class.border-primary-3px]="filtersCounter && filtersCounter > 0">
      <ate-icon [ngClass]="!filtersCounter || filtersCounter === 0 ? 'colorGreyBlue' : 'colorPrimary'" name="ate-filter-v3"></ate-icon>
      @if (!filtersCounter || filtersCounter === 0) {
        <span *ngIf="innerWidth > 599" class="colorGreyBlue">Filter</span>
      }
      @if (filtersCounter && filtersCounter > 0) {
        <span *ngIf="innerWidth > 599" class="colorPrimary">Filters</span>
        <span class="filters-indicator bgPrimary">
          <span>{{ filtersCounter }}</span>
        </span>
      }
    </button>

    <!-- Sort (mobile: icon button + menu) -->
    @if (innerWidth < 600) {
      <button
        class="ate-btn btn-sort tw-flex tw-items-center tw-justify-center tw-gap-[5px]"
        matTooltip="Sort"
        matTooltipPosition="above"
        [matMenuTriggerFor]="sortMenu">
        <ate-icon name="ate-arrows-sort"></ate-icon>
      </button>
      <mat-menu #sortMenu="matMenu">
        @for (option of sortOptions; track option.value) {
          <button
            mat-menu-item
            class="btn-sort-mobile tw-text-sm"
            [ngClass]="selectedSort === option.value ? 'btn-sort-active' : null"
            (click)="selectedSort = option.value; onSortChange()">
            {{ option.label }}
          </button>
        }
      </mat-menu>
    }

    <!-- Sort (desktop: select dropdown) -->
    @if (innerWidth >= 600) {
      <mat-form-field appearance="outline" class="filter-field filter-field--sort sort-select tw-w-[150px] tw-bg-white">
        <mat-label>Sort by</mat-label>
        <mat-select [(ngModel)]="selectedSort" (selectionChange)="onSortChange()">
          @for (option of sortOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
</div>

<!-- Filter bar pills (All | Active | Archived) -->
<div class="tw-mb-4 tw-px-4 md:tw-px-[10px] lg:tw-px-0">
  <ate-ui-filter-bar [filters]="filterBarItems"></ate-ui-filter-bar>
</div>

<!-- List content -->
<div
  class="tw-grid tw-overflow-hidden tw-border-b tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-slate-200 tw-bg-white md:tw-rounded-[5px] md:tw-border-l md:tw-border-r">
  <div
    class="tw-gap-4 tw-p-5 tw-text-gray-600"
    [ngClass]="isLoading || !customers?.length ? 'tw-flex tw-justify-center' : 'tw-grid md:tw-grid-cols-2'">
    @if (isLoading) {
      <ate-icon class="tw-m-auto tw-size-10 tw-animate-spin tw-text-white" name="loading-spinner-gradient-v3"></ate-icon>
    } @else {
      @if (!customers?.length) {
        <p class="tw-m-auto">
          @if (filtersCounter > 0 || searchTerm) {
            No customers found. Please change your search terms or remove filters.
          } @else if (isArchivedFilter === true) {
            You currently have no archived customers.
          } @else {
            No customers found.
          }
        </p>
      } @else {
        @for (customer of customers; track customer.uuid) {
          <customer-tile-component (update)="onSortChange()" [customer]="customer"></customer-tile-component>
        }
      }
    }
  </div>
</div>
@if (customers?.length && !isLoading) {
  <ate-pagination
    class="tw-mt-[20px] tw-px-[30px]"
    (onPageChange)="!isLoading && onPageChange($event)"
    [current]="pagination?.page"
    [pages]="pagination?.pageCount"
    [extremities]="false">
  </ate-pagination>
}
